import React from 'react';
import { checkboxPropTypes } from './CheckboxPropTypes';
const Checkbox = ({
  name,
  required,
  classname,
  value
}) => /*#__PURE__*/React.createElement("input", {
  value: value,
  name: name,
  type: "checkbox",
  required: required || null,
  className: classname || ''
});
export default Checkbox;